import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../hooks/useAppSelector';
import * as userSlice from '../../data/user.slice';
import AgreementDialog from './AgreementDialog';

interface EulaDialogProps {
  open: boolean;
  close: (version: number | null) => void;
}

export default function EulaDialog({ open, close }: EulaDialogProps) {
  const { t } = useTranslation('common');
  const eulaInfo = useAppSelector(userSlice.selectEULAInfo);

  const [html, setHtml] = React.useState<string>();
  const [eulaVersion, setEulaVersion] = React.useState<number | null>(null);

  React.useEffect(() => {
    if (eulaInfo) {
      setEulaVersion(eulaInfo?.supportAgreementID);
      fetch(eulaInfo?.supportAgreementFileNameWithPath).then((resp: any) =>
        resp.text().then((html: string) => setHtml(html)),
      );
    }
  }, [eulaInfo]);

  const handleCancel = () => {
    close(null);
  };

  const handleAgree = () => {
    close(eulaVersion);
  };

  if (!html) {
    return null;
  }

  return (
    <AgreementDialog
      open={open}
      title={t('eula.title')}
      html={html}
      acceptLabel={t('eula.agree')}
      cancelLabel={t('common.cancel')}
      onAccept={handleAgree}
      onClose={handleCancel}
    />
  );
}
